import React from 'react';
import Tooltip from "mrf/view/Tooltip";

export default function trim(s, length) {
    if(!s)
        return ''
    else{
        return s.length <= length
            ? s
            : s.substring(0, length - 3) + '...';
    }
}

export function trimCallback(length) {
    return s => trim(s, length);
}

export function trimCallbackTooltip(length) {
    return s => {
        let tooltipLines = [];

        if (s) {
            for (let i=0; i<s.length; i+=length)
            {
                tooltipLines.push(s.substring(i, i+length));
            }
        }

        return <Tooltip content={tooltipLines.join('\n')} maxWidth={10000} disableTranslation>{trim(s, length)}</Tooltip>;
    }
}
